<template>
  <div class="form-input" :data-layout="layout">
    <div class="form-input__body">
      <formLabel :label="label" :validation="validation" :required="isRequired"></formLabel>
      <input
        ref="input"
        :class="['form-input__input', {'form-input__input--error': errors.has(name)}]"
        v-validate="validation"
        :type="type"
        :name="name"
        :value="value"
        :placeholder="placeholder"
        @input="update($event)"
      >
    </div>
    <div class="form-input__footer">
      <slot></slot>
      <p
        class="form-input__error-message"
        v-show="errors.first(name)"
        v-html="errors.first(name)"
      ></p>
    </div>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'form-input',
  mixins: [mixin],
  props: {
    type: { type: String, default: 'text' },
    label: { type: String, default: ''},
    isRequired: {type: Boolean, default: false}
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.form-input {
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 1.4;
  color: $col_base_black;
  &__body {}
  &__footer {}
  &__input {
    appearance: none;
    display: block;
    width: 100%;
    padding: 9.5px 12px;
    border: 1px solid $col_temp_gray3;
    background: none;
    border-radius: 5px;
    line-height: inherit;
    outline: none;
    &::placeholder {
      color: #AAB2BD;
    }
    &--error {
      border-color: rgba($col_temp_key1, 0.6);
      background: rgba($col_temp_pink, 0.6);
    }
  }
  &__error-message {
    font-weight: bold;
    color: $col_temp_key1;
    font-size: 13px;
    margin-top: 6px;
    text-shadow: 0 0 5px #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/forms/FormInput.vue